webpackJsonp([64],{

/***/ "4Yp3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-router-modals-container_4b2639ec9693db06edec20cad7c8ffa1.html";

/***/ }),

/***/ "wg/K":
/***/ (function(module, exports, __webpack_require__) {

var SubscriptionRouterModalsContainer = (function () {
    function SubscriptionRouterModalsContainer() {
    }
    return SubscriptionRouterModalsContainer;
}());
angular.module('animatronApp.SubscriptionRouterModalsContainer', [])
    .component('subscriptionRouterModalsContainer', {
    controller: SubscriptionRouterModalsContainer,
    templateUrl: __webpack_require__("4Yp3")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/64-40ecf89b893baa28ab63.min.js